<template>
  <potager-container class="blog__body" size="small">
    <slot name="heading" />

    <div class="bg-white rounded-lg blog__content print:w-full print:max-w-full p-6">
      <template v-if="!isLoading">
        <slot />
      </template>

      <template v-else>
        <blog-section
          v-for="i in 3"
          :key="i"
          is-loading />
      </template>

      <slot name="pager" />
    </div>
  </potager-container>
</template>

<script>
import PotagerContainer from 'UI/PotagerContainer';
import PotagerRow from 'UI/PotagerRow';
import PotagerCol from 'UI/PotagerCol';

import BlogSection from 'Components/blog/BlogSection';

export default {
  components: {
    PotagerContainer,
    PotagerRow,
    PotagerCol,
    BlogSection,
  },

  props: {
    isLoading: {
      type: Boolean,
      required: false,
      default: false,
    },
    relatedRecipeBoxes: {
      type: Array,
      required: false,
      default: () => ([]),
    },
  },
};
</script>
